import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Presidents } from './presidents';

export const MeetTheTeamPage = ({ presidentsData }) => {
  const navigate = useNavigate();

  const styles = {
    container: {
      backgroundColor: "#d7ffd9",
      color: "#1b5e20",
      minHeight: "100vh",
      padding: "30px",
      paddingTop: "100px",
    },
    heading: {
      marginTop: 0,
      marginBottom: "30px",
      fontSize: "2.25rem",
      color: "#1b5e20",
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    aboutButtonsWrapper: {
      display: "flex",
      gap: "12px",
      marginBottom: "30px",
      flexWrap: "wrap",
    },
    aboutButton: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #2e7d32",
      backgroundColor: "transparent",
      color: "#1b5e20",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    aboutButtonActive: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #1b5e20",
      backgroundColor: "#2e7d32",
      color: "white",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "default",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Meet the Team</h1>
      <div style={styles.aboutButtonsWrapper}>
        <button style={styles.aboutButtonActive} aria-current="page">Meet the Team</button>
        <button onClick={() => navigate('/locations')} style={styles.aboutButton}>Locations</button>
        <button onClick={() => navigate('/events')} style={styles.aboutButton}>Events</button>
      </div>
      <Presidents data={presidentsData} />
    </div>
  );
};
